import jQuery from 'jquery'
import { getJSON } from './common'

export async function displayDirections(selector, lat, lng) {
  // - Désactivation de l'appel à cet endpoint pour des raisons de coût
  jQuery(selector).html(jQuery('<div>'));
  return;

  const results = await getJSON(`/wp-json/se-unsa-versailles/v1/nearby?location=${lat},${lng}`);

  const list = jQuery('<div>');

  if (results.length === 0) {
    jQuery(`<div class="info-line">
      <span class="info-icon icon">
        <i class="fas fa-lg" aria-hidden="true"></i>
      </span>
      <span class="info-content">Aucune station de train à moins de 5 km</span>
    </div>`).appendTo(list);
  }

  for (const result of _.sortBy(results, (item) => item.distance)) {
    const distanceResults = [];
    for (const [mode, value] of Object.entries(result.distance_matrix)) {
      // - On affiche pas la marche à pied de plus de 30min
      if (mode === 'walking' && value.duration.value > 30 * 60) continue;

      const directionUrl = `https://www.google.com/maps/dir/?api=1&origin=${lat},${lng}&destination=${result.location.lat},${result.location.lng}&travelmode=${mode}`;
      distanceResults.push(`<a href="${directionUrl}" target="_blank" class="mr-3 is-flex is-align-items-center" style="white-space: nowrap;">
        <span class="icon"><i class="fas ${mode === 'walking' ? 'fa-walking' : 'fa-biking'}" aria-hidden="true"></i></span>
        ${value.duration.text} (${value.distance.text})
      </a>`);
    }

    jQuery(`<div class="info-line">
      <span class="info-icon icon">
        <i class="fas ${result.type === 'train_station' ? 'fa-train' : 'fa-subway'} fa-lg" aria-hidden="true"></i>
      </span>
      <span class="info-content">
        ${result.name}
        <!-- <span class="has-text-weight-light has-text-grey is-size-7 ml-2" style="padding-top: 0.125em">${result.distance > 1000 ? `${Math.round(result.distance / 10) / 100} km` : `${result.distance} m`}</span> -->
        <span class="info-secondary" style="white-space: wrap;">
          ${distanceResults.join('\n')}
        </span>
      </span>
    <div>`).appendTo(list);
  }

  jQuery(selector).html(list);
}